import type {
    ProductDocumentsSearchRequest, ProductDocumentsSearchResponse,
    ProductShowItem, ProductShowRequest
} from "./types";
import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base";
import { Route } from "./route";

export const show = (payload: ProductShowRequest): AxiosPromise<ProductShowItem> => apiClient.get(Route.ProductShow, {
    params: {
        productId: payload.productId
    }
});

// Returns the raw ES envelope, like every other search endpoint in this app - unwrapping
// hits.hits into a plain array is the calling composable/store's job (via
// extractSearchResultItems), not this API module's. This one used to unwrap it here itself,
// which was the sole inconsistent exception.
export const retrieveDocuments = (payload: ProductDocumentsSearchRequest): AxiosPromise<ProductDocumentsSearchResponse> =>
    apiClient.post(Route.ProductDocumentsSearch, payload);